/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Standards_Preset_Deleted_ToastInputs */

const en_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const fr_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const de_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const it_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const ru_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const es_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const zh_cn2_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const ja_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const hi_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

const pt_pt2_standards_preset_deleted_toast = /** @type {(inputs: Standards_Preset_Deleted_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" deleted`)
};

/**
* | output |
* | --- |
* | "Standards preset \"{name}\" deleted" |
*
* @param {Standards_Preset_Deleted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_deleted_toast = /** @type {((inputs: Standards_Preset_Deleted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Deleted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_standards_preset_deleted_toast(inputs)
	if (locale === "de") return de_standards_preset_deleted_toast(inputs)
	if (locale === "it") return it_standards_preset_deleted_toast(inputs)
	if (locale === "ru") return ru_standards_preset_deleted_toast(inputs)
	if (locale === "es") return es_standards_preset_deleted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_standards_preset_deleted_toast(inputs)
	if (locale === "ja") return ja_standards_preset_deleted_toast(inputs)
	if (locale === "hi") return hi_standards_preset_deleted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_standards_preset_deleted_toast(inputs)
	return en_standards_preset_deleted_toast(inputs)
});